export default __webpack_public_path__ + "static/media/HumanMachine.e4ed6da6.png";